import { useState } from "react";
import "./styles/app.css"
import {Routes, Route } from "react-router-dom"

// Inicio
import Inicio from "./components/pages/inicio/Inicio"
import InicioSuscrito from "./components/pages/inicioSuscrito/InicioSuscrito"

// Sobre nosotros
import NuestraFirma from "./components/pages/quienesSomos/NuestraFirma";
import MisionYVision from "./components/pages/quienesSomos/MisionYVision";

// Servicios
import Servicios from "./components/pages/servicios/Servicios";
import AlumbradoPublico from "./components/pages/servicios/impuestosMunicipales/Alumbrado_publico"
import ComplementarioAvisos from "./components/pages/servicios/impuestosMunicipales/Complementario_avisos"
import ContribucionContratos from "./components/pages/servicios/impuestosMunicipales/Contribucion_contratos"
import DeguelloGanado from "./components/pages/servicios/impuestosMunicipales/Deguello_ganado"
import DelineacionUrbana from "./components/pages/servicios/impuestosMunicipales/Delineacion_urbana"
import EspectaculosPublicosNacional from "./components/pages/servicios/impuestosMunicipales/Espectaculos_publico_nacional"
import EspectaculoPublicoMunicipal from "./components/pages/servicios/impuestosMunicipales/Espectaculos_publicos_municipales"
import Estampillas from "./components/pages/servicios/impuestosMunicipales/Estampillas"
import ExplotacionMineralNacional from "./components/pages/servicios/impuestosMunicipales/Explotacion_mineral_nacional"
import FinanciarActividadBomberil from "./components/pages/servicios/impuestosMunicipales/Financiar_actividad_bomberil"
import IndustriaComercio from "./components/pages/servicios/impuestosMunicipales/Industria_comercio"
import PredialUnificado from "./components/pages/servicios/impuestosMunicipales/Predial_unificado"
import PublicidadExteriorVisual from "./components/pages/servicios/impuestosMunicipales/Publicidad_exterior_visual"
import SobreVehiculos from "./components/pages/servicios/impuestosMunicipales/Sobre_vehiculos"
import SobretasaAmbiental from "./components/pages/servicios/impuestosMunicipales/Sobretasa_ambiental"
import SobretasaCorporacionesRegionales from "./components/pages/servicios/impuestosMunicipales/Sobretasa_corporaciones_regionales"
import SobretasaGasolina from "./components/pages/servicios/impuestosMunicipales/Sobretasa_gasolina"
import TransporteOleoGaso from "./components/pages/servicios/impuestosMunicipales/Transporte_oleo_gaso"
import VentaSistemaClubes from "./components/pages/servicios/impuestosMunicipales/Venta_sistema_clubes"

// Servicios/tasas
import Tasas from "./components/pages/servicios/impuestosMunicipales/tasas/Tasas";
import DerechoTrancito from "./components/pages/servicios/impuestosMunicipales/tasas/Derecho_trancito"
import PeajeEstacionamiento from "./components/pages/servicios/impuestosMunicipales/tasas/Peaje_estacionamiento"
import PeajeTuristico from "./components/pages/servicios/impuestosMunicipales/tasas/Peaje_turistico"
import Retributibas from "./components/pages/servicios/impuestosMunicipales/tasas/Retributibas"
import UtilizacionAgua from "./components/pages/servicios/impuestosMunicipales/tasas/Utilizacion_agua"

// Servicios/contribuciones 
import Contribuciones from "./components/pages/servicios/impuestosMunicipales/contribuciones/Contribuciones";
import ParticipacionPlusvalia from "./components/pages/servicios/impuestosMunicipales/contribuciones/Participacion_plusvalia"
import TransferenciaSectorElectrico from "./components/pages/servicios/impuestosMunicipales/contribuciones/Transferencia_sector_electrico"
import ValorizacionMunicipal from "./components/pages/servicios/impuestosMunicipales/contribuciones/Valorizacion_municipal"

//Blog
import Blog from "./components/pages/suscrito/Blog";

// Pages Links in the navbars
import Contacto from "./components/pages/contacto/Contacto";
import NuestrosClientes from "./components/pages/clientes/Nuestros_clientes";

// Logins
import LoginAndRegister from "./components/pages/login/LoginAndRegister";
import LoginSolo from "./components/pages/login/LoginSolo";

//registrarse
import Suscribirse from "./components/pages/suscripciones/Suscribirse";

// Slides noticias
import SlideNoticias1 from "./components/Reutilizables/registrado/noticias/SlideNoticias1";
import SlideNoticias2 from "./components/Reutilizables/registrado/noticias/SlideNoticias2";
import SlideNoticias3 from "./components/Reutilizables/registrado/noticias/SlideNoticias3";
import SlideNoticias4 from "./components/Reutilizables/registrado/noticias/SlideNoticias4";

import Ventajas from "./components/pages/Ventajas"
import Page404 from "./components/pages/Page404";

import firebaseApp from "./components/firebase/Credenciales"
import {getAuth, onAuthStateChanged} from "firebase/auth"
import { getFirestore, doc, getDoc } from "firebase/firestore";

const auth = getAuth(firebaseApp)
const firestore = getFirestore(firebaseApp)

function App() {

  const [user, setUser] = useState(null)

  async function getusuarioNombre(uid) {
    const docuRef = doc(firestore, `usuarios/${uid}`)
    const docuCifrada = await getDoc(docuRef)
    const infoFinal = docuCifrada.data()
    /* console.log("infoFinal" ,infoFinal); */
    return infoFinal
  }

  function setUserWithFirebaseAndusuarioNombre(usuarioFirebase) {
    getusuarioNombre(usuarioFirebase.uid).then((usuarioNombre) => {
      let userData = {
        uid: usuarioFirebase.uid,
        email: usuarioFirebase.email,
        usuarioNombre: usuarioNombre.usuarioNombre
      }
      setUser(userData)
      /* console.log("userData final", userData); */
    })
  }

  onAuthStateChanged(auth, (usuarioFirebase)=>{
    if (usuarioFirebase) {
      if (!user) {
        setUserWithFirebaseAndusuarioNombre(usuarioFirebase)
      }
    } else {
      setUser(null)
    }
  })

  return (
    <div className="App">
      <Routes>
        {/* Inicio */}
        <Route path="/" element={ user ? <InicioSuscrito user={user}/> : <Inicio/> } />

        {/* Sobre nosotros */}
        <Route path="nuestra-firma" element={ <NuestraFirma user={user}/> } />
        <Route path="mision-y-vision" element={ <MisionYVision user={user}/> } />

        {/* Servicios */}
        <Route path="servicios" element={ <Servicios user={user}/> } />
        <Route path="servicios-alumbrado-publico" element={ <AlumbradoPublico /> } />
        <Route path="servicios-complementario-avisos" element={ <ComplementarioAvisos /> } />
        <Route path="servicios-contribucion-contratos" element={ <ContribucionContratos /> } />
        <Route path="servicios-deguello-ganado" element={ <DeguelloGanado /> } />
        <Route path="servicios-delineacion-urbana" element={ <DelineacionUrbana /> } />
        <Route path="servicios-espectaculos-publicos-nacional" element={ <EspectaculosPublicosNacional /> } />
        <Route path="servicios-espectaculo-publico-municipal" element={ <EspectaculoPublicoMunicipal /> } />
        <Route path="servicios-estampillas" element={ <Estampillas /> } />
        <Route path="servicios-explotacion-mineral-nacional" element={ <ExplotacionMineralNacional /> } />
        <Route path="servicios-financiar-actividad-bomberil" element={ <FinanciarActividadBomberil /> } />
        <Route path="servicios-industria-comercio" element={ <IndustriaComercio /> } />
        <Route path="servicios-predial-unificado" element={ <PredialUnificado /> } />
        <Route path="servicios-publicidad-exterior-visual" element={ <PublicidadExteriorVisual /> } />
        <Route path="servicios-sobre-vehiculos" element={ <SobreVehiculos /> } />
        <Route path="servicios-sobretasa-ambiental" element={ <SobretasaAmbiental /> } />
        <Route path="servicios-sobretasa-corporaciones-regionales" element={ <SobretasaCorporacionesRegionales /> } />
        <Route path="servicios-sobretasa-gasolina" element={ <SobretasaGasolina /> } />
        <Route path="servicios-transporte-oleo-gaso" element={ <TransporteOleoGaso /> } />
        <Route path="servicios-venta-sistema-clubes" element={ <VentaSistemaClubes /> } />

        {/* Servicios/tasas */}
        <Route path="servicios-tasas" element={ <Tasas /> } />
        <Route path="servicios-tasas-derecho-trancito" element={ <DerechoTrancito /> } />
        <Route path="servicios-tasas-peaje-estacionamiento" element={ <PeajeEstacionamiento /> } />
        <Route path="servicios-tasas-peaje-turistico" element={ <PeajeTuristico /> } />
        <Route path="servicios-tasas-retributibas" element={ <Retributibas /> } />
        <Route path="servicios-tasas-utilizacion-agua" element={ <UtilizacionAgua /> } />

        {/* Servicios/contribuciones */}
        <Route path="servicios-contribuciones" element={ <Contribuciones /> } />
        <Route path="servicios-contribuciones-participacion-plusvalia" element={ <ParticipacionPlusvalia /> } />
        <Route path="servicios-contribuciones-transferencia-sector-electrico" element={ <TransferenciaSectorElectrico /> } />
        <Route path="servicios-contribuciones-valorizacion-municipal" element={ <ValorizacionMunicipal /> } />

        {/* Blog */}
        <Route path="blog-tributos-y-finanzas" element={ <Blog /> } />
  
        {/* Page Link Navbar */}
        <Route path="contacto" element={ <Contacto user={user}/> } />
        <Route path="nuestros-clientes" element={ <NuestrosClientes user={user}/> } />

        {/* Logins */}
        <Route path="login" element={ <LoginAndRegister /> } />
        <Route path="login-simple" element={ <LoginSolo /> } />

        {/* Registrarse */}

        <Route path="registrarse" element={<Suscribirse />} />

        {/* Slides noticias */}
        <Route path="noticias-slide1" element={<SlideNoticias1 />} />
        <Route path="noticias-slide2" element={<SlideNoticias2 />} />
        <Route path="noticias-slide3" element={<SlideNoticias3 />} />
        <Route path="noticias-slide4" element={<SlideNoticias4 />} />

        <Route path="ventajas" element={ <Ventajas /> } />
  
        <Route path="*" element={ <Page404 /> } />

      </Routes>
    </div>
  );
}

export default App;
